import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(main)/orders/page.tsx");
